var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtility5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5417 0H0.5V15.0417H15.5417V0Z",
    fill: "#34A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5007 0H23.459V15.0417H38.5007V0Z",
    fill: "#34A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5417 22.9584H0.5V38H15.5417V22.9584Z",
    fill: "#34A9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_3598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility5);
export default __webpack_public_path__ + "static/media/utility5.5d9da2b1685ba11444a156772221ffc6.svg";
export { ForwardRef as ReactComponent };